export default function({ req, store }) {
  if (process.server) {
    store.dispatch('analytics/setReferrer', req.headers.referer)
  }
  if (process.client) {
    store.dispatch('analytics/setReferrer', window.document.referrer)
  }
}
